<template>
  <b-dropdown-item @click="$emit('give-pdf-pass')">
    <img :src="iconPath('v_print.svg')" alt="" class="icon-pdf">
    {{ this.title }}
  </b-dropdown-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>
